// stores/previewStore.ts
import { create } from 'zustand';
import { PreviewData, PreviewOptions } from '../services/previewEngine';

interface PreviewState {
  isOpen: boolean;
  data: PreviewData | null;
  options: PreviewOptions;
  isLoading: boolean;
  setOpen: (open: boolean) => void;
  setData: (data: PreviewData | null) => void;
  setOptions: (options: PreviewOptions) => void;
  setLoading: (loading: boolean) => void;
}

export const usePreviewStore = create<PreviewState>((set, get) => ({
  isOpen: false,
  data: null,
  options: { zoom: 100, format: 'portrait', quality: 'standard' },
  isLoading: false,
  setOpen: (open) => set({ isOpen: open }),
  setData: (data) => set({ data }),
  setOptions: (options) => {
    const current = get().options;
    // Shallow comparison to prevent unnecessary updates
    if (JSON.stringify(current) !== JSON.stringify(options)) {
      set({ options });
    }
  },
  setLoading: (loading) => set({ isLoading: loading })
}));